export default __webpack_public_path__ + "static/media/consumer-trying-new-product.61b445de.png";